export default __webpack_public_path__ + "static/media/chip_5000.be83a5d9.svg";